module.exports = __webpack_public_path__ + "img/icon_wait_proxy.aa0db262.svg";